import React from "react";
import { useContext, useRef } from "react";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import ActionButton from "components/ui/controls/action-button/ActionButton";
import { FaDownload, FaUpload } from "react-icons/fa";
import { RISContext } from "./RISProvider";
import { AppContext } from "components/app/RemExprertProvider";
import queryString from "query-string";
import { AnalyseCarriereWord } from "components/app/Api/Rapport/ApiRapport";
import InfoMessage from "components/ui/controls/info-message/info-message";
import { OkMessage, WarningMessage } from "components/ui/controls/info-message";

const LectureRIS = (props) => {
  const { ClientConjoint } = props;
  const context = useContext(AppContext);
  const RIS = useContext(RISContext);
  const Params = queryString.parse(window.location.search);
  const fileInputRef = useRef(null);

  const handleFileUpload = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (evt) => {
    if (evt.target.files[0]) {
      RIS.handleUploadRIS(context.state)(evt, evt.target.files[0]);
    }
  };
  return (
    <>
      <Column fill>
        <CardBox>
          <Column fill>
            <Row>
              {Params.Partner === "PLPSOFT" && (
                <blockquote>
                  Seul le relevé "tous régimes" directement téléchargé du site de l'assurance retraite à compter du 1er juillet 2021 doit être importé dans le logiciel (
                  <a target="_blank" rel="noreferrer" href="https://www.plpsoft.com/espace-documentaire/tutoriels/haumeal/module_retraite/simulateur-bilan-retraite.html">
                    procédure
                  </a>
                  ). Nous vous avertissons que les scans ou les fichiers convertis par des applications (notamment sur Mac), ne fonctionneront pas. En dehors de ces cas et en cas de
                  difficulté, nous vous invitons à nous transférer le relevé par mail.
                </blockquote>
              )}
              {Params.Partner !== "PLPSOFT" && (
                <InfoMessage
                  text={
                    <>
                      Seul le relevé "tous régimes" directement téléchargé du site de l'assurance retraite à compter du 1er juillet 2021 doit être importé dans le logiciel (
                      <a target="_blank" rel="noreferrer" href=" https://api-v3.mako-box.com/ApiMako/V3/Documents/Procédure d'import.pdf">
                        procédure
                      </a>
                      ). Nous vous avertissons que les scans ou les fichiers convertis par des applications (notamment sur Mac), ne fonctionneront pas. En dehors de ces cas et en cas de
                      difficulté, nous vous invitons à nous transférer le relevé par mail. Attention, nous vous informons que nous ne pouvons pas garantir une lecture parfaite du relevé de
                      carrière lors de l'import. Nous vous conseillons vivement de vérifier les données importées.
                    </>
                  }
                />
              )}
            </Row>
            <Row tpad bpad>
              <input ref={fileInputRef} type="file" style={{ display: "none" }} onChange={handleFileChange} accept=".pdf" />
              <ActionButton
                onClick={handleFileUpload}
                icon={FaUpload}
                title="Importer un fichier"
                subtitle="Relevé tous régimes PDF"
                colors={{
                  primary: "#3b82f6",
                  secondary: "#1d4ed8",
                  shadow: "rgba(59, 130, 246, 0.4)",
                  shadowHover: "rgba(59, 130, 246, 0.6)",
                }}
                decorativeIcon={{ type: "upload" }}
              />
            </Row>

            {RIS.ErrorMessage !== "" && (
              <Row tpad>
                <WarningMessage text={<>{RIS.ErrorMessage}</>} />
              </Row>
            )}
            {RIS.SuccessMessage === true && (
              <>
                {/* {console.log(RIS)} */}
                <Row tpad>
                  <OkMessage
                    text={
                      <>
                        Votre rélévé individuel de situation a bien été importé.
                        <br />
                        Des précisions peuvent être apportées en cliquant dans l'onglet suivant.
                      </>
                    }
                  />
                </Row>
                <Row tpad>
                  <ActionButton
                    onClick={() => {
                      AnalyseCarriereWord(context.state, RIS.InfosRIS, ClientConjoint).then((res) => {});
                    }}
                    icon={FaDownload}
                    title={`Editer l'analyse de la carrière pour ${context.state["Prenom" + ClientConjoint]}`}
                    subtitle="Génération du rapport"
                    colors={{
                      primary: "#11998e",
                      secondary: "#0d7377",
                      shadow: "rgba(17, 153, 142, 0.4)",
                      shadowHover: "rgba(17, 153, 142, 0.6)",
                    }}
                    decorativeIcon={{ type: "document" }}
                  />
                </Row>
              </>
            )}
          </Column>
        </CardBox>
      </Column>
    </>
  );
};
export default LectureRIS;
